import { LICENSE_TYPE } from '@/consts/common';
import { ILicenseType } from '@/services/licenses/types';

export interface LicenseColourConfig {
  bgColor: string;
  textColor: string;
}

export const DEFAULT_LICENSE_COLOR_CONFIG: LicenseColourConfig = {
  bgColor: '#E0E0E0',
  textColor: '#000000',
};

export const licenseColorMap: Record<ILicenseType, LicenseColourConfig> = {
  [LICENSE_TYPE.ALL]: {
    bgColor: '#E0E0E0',
    textColor: '#000000',
  },
  [LICENSE_TYPE.ENTERPRISE]: {
    bgColor: '#E7F7EF',
    textColor: '#0B6B3A',
  },
  [LICENSE_TYPE.PREMIUM]: {
    bgColor: '#F3E8FF',
    textColor: '#5B21B6',
  },
  [LICENSE_TYPE.BASIC]: {
    bgColor: '#F1F6FF',
    textColor: '#1A125A',
  },
  [LICENSE_TYPE.UNLICENSED]: {
    bgColor: '#FFD7DF',
    textColor: '#B00020',
  },
};

export const getLicenseColors = (licenseType: ILicenseType): LicenseColourConfig => (
  licenseColorMap[licenseType] ?? DEFAULT_LICENSE_COLOR_CONFIG
);
